export const COLOR = {
    BASE: {
        PAGE: '#011c39',
        DIVIDER: '#234369',
        SCRIM_LIGHT: 'rgba(0, 0, 0, 0.6)',
        SCRIM_DARK: 'rgba(0, 0, 0, 0.8)',
        SHADOW_SHORT: 'rgba(0, 0, 0, 0.3)',
        SHADOW_LONG: 'rgba(0, 0, 0, 0.5)',
    },
    BRAND: {
        BACKGROUND1: '#002551',
        BACKGROUND2: '#002551',
        BACKGROUND3: '#204792',
        BACKGROUND4: '#083476',
        BACKGROUND5: '#063678',
        BACKGROUND6: '#0d1b2c',
        BACKGROUND7: '#111111',
        BACKGROUND8: '#434f5b',
        FOREGROUND1: '#ffffff',
        FOREGROUND2: '#f3f2f2',
        FOREGROUND3: '#c1c1c1',
        FOREGROUND4: '#e8e8e8',
        FOREGROUND5: '#ffffff',
        FOREGROUND6: '#254469',
        FOREGROUND7: '#002551',
        ACCENT1: '#056ff7',
        ACCENT2: '#ffcc00',
        ACCENT3: '#3666a9',
        CTA1: '#00a723',
        CTA2: '#ffcc00',
    },
    SEMANTIC: {
        ERROR1: '#fb4444',
        ERROR2: '#ffd8d8',
        WARNING1: '#fbe044',
        WARNING2: '#fdf3b7',
        SUCCESS1: '#00ba91',
        SUCCESS2: '#bfebe1',
    },
    RESERVED: {
        BLACK: '#2d2d2e',
        WHITE: '#f9f9f9',
        TRANSPARENT: 'rgba(249, 249, 249, 0)',
        ACCENT: '#056ff7',
        BLUE1: '#3e82f7',
    },
};

export const FONT = {
    FAMILY: 'Barlow, sans-serif',
    FAMILY_SECOND: 'BarlowCondensed, sans-serif',

    WEIGHT_NORMAL: 400,
    WEIGHT_SEMI_BOLD: 500,
    WEIGHT_BOLD: 600,

    SIZE_XXSMALL: 12,
    SIZE_XSMALL: 12,
    SIZE_SMALL: 13,
    SIZE_MEDIUM: 14,
    SIZE_LARGE: 16,
    SIZE_XLARGE: 18,
};

export const BASIC_PALETTE = {
    FONT_FAMILY: 'Barlow, sans-serif',
    FONT_HEADER4: {
        fontFamily: FONT.FAMILY_SECOND,
        fontWeight: FONT.WEIGHT_SEMI_BOLD,
        fontSize: FONT.SIZE_LARGE,
        textTransform: 'uppercase',
    },

    FILL_PAGE: COLOR.BASE.PAGE,
    FILL_HEADER: COLOR.BRAND.BACKGROUND1,
    FILL_HERO: COLOR.BRAND.BACKGROUND1,
    FILL_SHEET: COLOR.BRAND.BACKGROUND4,
    FILL_POPOVER: COLOR.BRAND.FOREGROUND6,

    DEFAULT_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
    FILL_CONTENT_PROMINENT: COLOR.BRAND.BACKGROUND1,

    FILL_CARD: COLOR.BRAND.BACKGROUND3,
    FILL_CARD_PROMINENT: COLOR.BRAND.BACKGROUND3,

    FILL_CONTROL_OUTLINE: `${COLOR.BRAND.FOREGROUND7}|${COLOR.BRAND.FOREGROUND1}`,
    FILL_CONTROL_ACCENT: COLOR.BRAND.ACCENT1,
    FILL_CONTROL_ODDS: COLOR.BRAND.BACKGROUND5,

    FILL_ACCENT_PRIMARY: '#ffcc00',
    FILL_ACCENT_SECONDARY: '#056ff7',
    FILL_ACCENT_FOCUS: COLOR.BRAND.ACCENT1,

    FILL_SELECTED_PRIMARY: COLOR.BRAND.ACCENT1,
    FILL_SELECTED_ODDS: COLOR.BRAND.ACCENT1,

    DEFAULT_PRIMARY_TEXT: `${COLOR.BRAND.FOREGROUND7}|${COLOR.BRAND.FOREGROUND1}`,
    DEFAULT_SECONDARY_TEXT: `${COLOR.BRAND.FOREGROUND7}|${COLOR.BRAND.FOREGROUND2}`,

    TEXT_ACCENT_PRIMARY: '#003a2a',
    TEXT_ACCENT_SECONDARY: '#003a2a',
    TEXT_ACCENT_FILL: '#ffcc00',

    DEFAULT_GENERIC_ACCENT_COLOR: COLOR.BRAND.CTA2,
    DEFAULT_DIVIDER: COLOR.BASE.DIVIDER,

    DEFAULT_BUTTON_BORDER_RADIUS: 4,
    DEFAULT_BOX_DECORATION_WITH_SHADOW: true,
};
